<template>
  <div class="course-apply-form">
    <page-header :title="pageTitle" :data="pageHeaderArr" />
    <!-- {{ +apply_type }} -->
    <!-- 缓修，缓考、免修不免考、免修免考 -->
    <template v-if="[1, 3, 6, 7].includes(+apply_type)">
      <apply-form-one :type="+apply_type" />
    </template>
    <!-- 再考、缓修在修、重修 -->
    <template v-if="[2, 4, 5].includes(+apply_type)">
      <apply-form-two :type="+apply_type" />
    </template>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import Store from '@/store'
import Router from '@/router'
import PageHeader from '@/components/PageHeader'
import ApplyFormOne from './components/ApplyFormOne.vue'
import ApplyFormTwo from './components/ApplyFormTwo.vue'

const userInfo = computed(() => {
  return Store.state.user.userInfo
})
const applyTypes = computed(() => {
  return Store.state.common.courseApplyTypes
})
const graduationDate = computed(() => {
  return Store.state.user.graduationDate
})
const pageTitle = ref('申请单')
const apply_type = ref('1')
const {
  params: { typeid }
} = Router.currentRoute
const title = applyTypes.value.filter(item => item.id === +typeid)[0].title
apply_type.value = typeid

pageTitle.value = title + pageTitle.value

const pageHeaderArr = ref([
  {
    title: '学号',
    value: userInfo.value.idnumber || '-'
  },
  {
    title: ' 班级',
    value: userInfo.value.className || '-'
  },
  {
    title: ' 预计毕业日期',
    value: graduationDate.value || '-'
  }
])
</script>
